require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./microtechnique-2-1-3-7.json") })
        }
      }, "path---microtechnique-2-1-3-7");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---microtechnique-2-1-3-7!./.cache/json/microtechnique-2-1-3-7.json
// module id = 495
// module chunks = 231608221292675